<template>
  <div class="archivoContainer">
    <div v-for="item in archivos" :key="item.Id">
      <ArchivoCard :archivo="item" :esBusqueda="false" />
    </div>
  </div>
</template>

<script>
  import ArchivoCard from '../Cards/archivoCard'

  export default {
    name: "HomeArchivo",
    components: { ArchivoCard },
    props: {
      data: { propType: Array, default: [] }
    },

    data() {
      return {
        archivos: this.data,
      }
    },

    watch: {
      data(newVal) {
        this.archivos = newVal
      }
    }
  }

</script>

<style scoped>

  .archivoContainer > div {
    margin-bottom: 15px;
  }

</style>